import { Component } from '@angular/core';
import { AppInsightsService } from '@sb-tools/typescript/services/app-insights.service';
import { RouterOutlet } from '@angular/router';
import { SimpleNotificationsModule } from 'angular2-notifications';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, SimpleNotificationsModule],
})
export class AppComponent {
    constructor(private appInsightsService: AppInsightsService) {
        this.appInsightsService.init();
    }
}
